module.exports = __webpack_public_path__ + "static/media/barcodeImage_aztec.39f5b302.svg";